import { connect } from 'react-redux';

import ManagementIndex from '../components/management/Index';

const Index = connect()(ManagementIndex);

export default Index;


/** WEBPACK FOOTER **
 ** ./src/containers/Management.js
 **/